import RefundTask from "./Refund/RefundTask"

const components = {
    RefundTask,
   // AnotherTestTask,
};

export default components;